import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ImmutableUser } from './UserPropTypes';

export const CourseOutcome = PropTypes.shape({
  description: PropTypes.string.isRequired,
  _id: PropTypes.string.isRequired,
  tag: PropTypes.string.isRequired,
});

export const Course = PropTypes.shape({
  objective: PropTypes.string.isRequired,
  outcomes: PropTypes.arrayOf(CourseOutcome).isRequired,
  admins: PropTypes.arrayOf(PropTypes.string).isRequired,
  name: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  createdBy: PropTypes.string.isRequired,
  institution: PropTypes.string,
});

export const CoursesPropType = PropTypes.arrayOf(
  PropTypes.shape({
    course: Course,
  })
);

export const ImmutableCourseOutcome = ImmutablePropTypes.mapContains({
  description: PropTypes.string.isRequired,
  _id: PropTypes.string.isRequired,
  tag: PropTypes.string.isRequired,
});

export const ImmutableCourseOutcomesList = ImmutablePropTypes.listOf(
  ImmutableCourseOutcome
);

export const ImmutableCourse = ImmutablePropTypes.mapContains({
  objective: PropTypes.string.isRequired,
  outcomes: ImmutableCourseOutcomesList.isRequired,
  admins: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  name: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  createdBy: PropTypes.string.isRequired,
  institution: PropTypes.string,
});

export const ImmutableCourseCheckStatus = ImmutablePropTypes.mapContains({
  checked: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});

export const ImmutableCourseCheckBoxList = ImmutablePropTypes.listOf(
  ImmutableCourseCheckStatus
);

export const CourseData = PropTypes.shape({
  MEDIA_URL: PropTypes.string.isRequired,
  category: ImmutablePropTypes.mapContains({
    code: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
  categoryIcon: ImmutablePropTypes.listOf(PropTypes.string),
  courseSummary: PropTypes.string.isRequired,
  courseUrl: PropTypes.string.isRequired,
  creator: ImmutableUser,
  currency: PropTypes.string,
  featured: PropTypes.bool.isRequired,
  homeFeatured: PropTypes.bool.isRequired,
  image: PropTypes.string,
  landingPage: ImmutablePropTypes.mapContains({
    content: PropTypes.string.isRequired,
    summary: PropTypes.string.isRequired,
  }),
  name: PropTypes.string.isRequired,
  paidCohort: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  startDate: PropTypes.string,
  startDateISO: PropTypes.string,
  studentPrice: PropTypes.number,
  students: PropTypes.number,
});

export const ImmutableCourseData = ImmutablePropTypes.mapContains({
  MEDIA_URL: PropTypes.string.isRequired,
  category: ImmutablePropTypes.mapContains({
    code: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
  categoryIcon: ImmutablePropTypes.listOf(PropTypes.string),
  courseSummary: PropTypes.string.isRequired,
  courseUrl: PropTypes.string.isRequired,
  creator: ImmutableUser,
  currency: PropTypes.string,
  featured: PropTypes.bool.isRequired,
  homeFeatured: PropTypes.bool.isRequired,
  image: PropTypes.string,
  landingPage: ImmutablePropTypes.mapContains({
    content: PropTypes.string.isRequired,
    summary: PropTypes.string.isRequired,
  }),
  name: PropTypes.string.isRequired,
  paidCohort: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  startDate: PropTypes.string,
  startDateISO: PropTypes.string,
  studentPrice: PropTypes.number,
  students: PropTypes.number,
});

export const ImmutableCourseNavigationLinks = ImmutablePropTypes.listOf(
  ImmutablePropTypes.contains({
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    url: PropTypes.string,
    pagePath: PropTypes.string,
    external: PropTypes.bool,
    type: PropTypes.string.isRequired,
    icon: PropTypes.string,
  })
);

export const ImmutableCourseNavigationMeta = ImmutablePropTypes.mapContains({
  error: PropTypes.bool,
  loading: PropTypes.bool,
  cohortPath: PropTypes.string,
  coursePath: PropTypes.string,
});

export const ImmutableCourseNavigation = ImmutablePropTypes.mapContains({
  error: PropTypes.bool,
  loading: PropTypes.bool,
  cohortPath: PropTypes.string,
  coursePath: PropTypes.string,
  navigations: ImmutableCourseNavigationLinks,
});
